import { changePasswordActionsStyles as styles } from "@insite/content-library/Widgets/ChangePassword/ChangePasswordActions";


styles.cancelButton = {
    ...styles.cancelButton,
    variant: "secondary",
};
